import React from 'react';
import { BookOpenIcon, GiftIcon, CreditCardIcon, BadgeCheckIcon, FileTextIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CtaButton } from './CtaButton';
const details = [{
  icon: BookOpenIcon,
  title: '6 tomos completos',
  text: 'Todo el libro digital, del primer paso al último proyecto.'
}, {
  icon: GiftIcon,
  title: '5 bonos gratis',
  text: 'Checklists, guías y plantillas incluidas sin costo extra.'
}, {
  icon: CreditCardIcon,
  title: 'Pagás con Mercado Pago',
  text: 'Checkout seguro con los medios de pago que ya usás.'
}, {
  icon: BadgeCheckIcon,
  title: 'Único pago',
  text: 'Sin suscripciones ni cobros mensuales. Pagás una sola vez.'
}, {
  icon: FileTextIcon,
  title: 'Acceso vía PDF',
  text: 'Descargalo al instante y leelo en el celular, tablet o compu.'
}];
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full bg-cream" data-id="element-118" data-mp="2affucap6kp1b">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-119" data-mp="ujboca4oseyq">
        <Reveal data-id="element-120" data-mp="uhh3evtf0mun">
          <div className="rounded-[2.5rem] border-2 border-ink bg-sand p-7 shadow-block sm:p-12" data-id="element-121" data-mp="ul4y3yaljfay">
            <SectionLabel data-id="element-122" data-mp="zgk9mjl4sz47">La oferta</SectionLabel>
            <h2 id="oferta-titulo" className="mt-4 max-w-2xl font-display text-3xl font-bold leading-tight sm:text-[2.5rem]" data-id="element-123" data-mp="13iys32kw1wuy">
              Esto es exactamente lo que te llevás hoy
            </h2>
            <p className="mt-4 max-w-2xl text-lg text-graphite" data-id="element-124" data-mp="bqpxk48mzel0">
              Un solo pago, acceso inmediato y todo el material listo para
              descargar.
            </p>

            <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-125" data-mp="kmp7dwfhe81z">
              {details.map(({
              icon: Icon,
              title,
              text
            }, i) => <li key={title} className={`flex items-start gap-4 rounded-3xl border-2 border-ink/12 bg-cream p-5 ${i === details.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-126" data-mp="3k6t2414gcn54" data-mpi={i}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-clay text-cream" data-id="element-127" data-mp="qg4k7tr3nyjx">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="157mudaxa2yvd" />
                  </span>
                  <div data-id="element-129" data-mp="1078w2klhb3aj">
                    <h3 className="font-display text-lg font-bold leading-snug" data-id="element-130" data-mp="cgv4ev6t36gh">
                      {title}
                    </h3>
                    <p className="mt-1 text-[15px] leading-relaxed text-graphite" data-id="element-131" data-mp="7il466685fo0">
                      {text}
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="mt-9 flex flex-col gap-6 rounded-3xl border-2 border-ink bg-ink p-6 text-cream sm:flex-row sm:items-center sm:justify-between sm:p-8" data-id="element-132" data-mp="hf6e95x3pgyp">
              <div data-id="element-133" data-mp="1sveh78gg2uaw">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-cream/60" data-id="element-134" data-mp="1svwfeamo3ilg">
                  Precio final · Único pago
                </p>
                <p className="mt-2 font-display text-5xl font-bold leading-none sm:text-6xl" data-id="element-135" data-mp="25dqmnwmydovs">
                  $28.990
                </p>
                <p className="mt-3 text-sm text-cream/70" data-id="element-136" data-mp="1qhj38yjdcrhk">
                  6 tomos + 5 bonos gratis · Acceso vía PDF
                </p>
              </div>
              <div className="sm:text-right" data-id="element-137" data-mp="2j556u6sljw4f">
                <CtaButton size="lg" data-id="element-138" data-mp="2j6ga85i4r1v0">Quiero acceso inmediato</CtaButton>
                <p className="mt-3 text-sm font-medium text-cream/70" data-id="element-139" data-mp="2o4riwcwov6bn">
                  Pagás con Mercado Pago · Descarga inmediata
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}